module.exports = __webpack_public_path__ + "static/media/Personalized-Trends.3740ffd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/Personalized-Trends.png
// module id = 456
// module chunks = 0